<template>
  <div class="sales-statistics">


    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="老师统计" name="first">
        <el-form class="select">

            <el-form-item label="教师姓名:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择"
                v-model="teacherName"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in teacherArr"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                >
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="课消次数:" label-width="100px" style="width: 30%;">
              <el-input
                placeholder="请输入课消次数"
                v-model="cancellationsNumber"
                :onkeyup="cancellationsNumber = cancellationsNumber.replace(/[\u4E00-\u9FA5]/g,'')"
                style="width: 100%"
                clearable
              ></el-input>
            </el-form-item>


            <el-form-item label="课消金额:" label-width="100px" style="width: 30%;">
              <el-input
                placeholder="请输入课消金额"
                v-model="cancellationsMoney"
                :onkeyup="cancellationsMoney = cancellationsMoney.replace(/[\u4E00-\u9FA5]/g,'')"
                style="width: 100%"
                clearable
              ></el-input>
            </el-form-item>


            <el-form-item label="学生类型:" label-width="100px" style="width: 30%;">
              <el-select v-model="newClassType"  filterable placeholder="请选择学生类型"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in newClassTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="所在地域:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择所在地域"
                v-model="regionName"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in optionsListt"
                  :key="item.id"
                  :value="item.dictType"
                  :label="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="课程类别:" label-width="100px" style="width: 30%;">
              <el-select  placeholder="请选择课程类别"  v-model="courseCategoryIds" style="width: 100%"  clearable filterable >
                <el-option  v-for="item in categoryList"  :key="item.id"  :value="item.id" :label="item.categoryName"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="日期:" label-width="100px" style="width: 50%;text-align: justify;">
              <el-date-picker
                v-model="dateTimeList"
                type="daterange"
                style="width: 100%;"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>


            <el-form-item label="渠道:" label-width="100px" style="width: 30%;">
              <el-select clearable filterable  style="width:100%;"  v-model="channelType" placeholder="请选择渠道">
                <el-option v-for="teacher in DealTypeListt" :key="teacher.value" :value="teacher.value" :label="teacher.label">
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item style="width: 100%;">
              <div style="display: flex;">
                <div style="width: 55%;">

                    <div style="display: flex;">
                      <span
                      style="
                        font-weight: 900;

                        width: 400px;
                        background-color: #f58c4b;
                        height: 30px;
                        border-radius: 10px;
                        padding: 5px 0px;
                        margin-bottom: 10px;
                        text-align: start;
                        line-height: 26px;
                        padding-left: 10px;
                        margin-left: 100px;
                        padding-left: 17px;
                      "
                    > 实际课消次数:{{ dataTop.actualNumCount }} </span>

                    <span
                      style="
                        font-weight: 900;

                        width: 400px;
                        background-color: #d1c633;
                        height: 30px;
                        border-radius: 10px;
                        padding: 5px 0px;
                        margin-bottom: 10px;
                        text-align: start;
                        line-height: 26px;
                        padding-left: 10px;
                        margin-left: 100px;
                        padding-left: 17px;
                      "
                    > 实际课消金额:{{ dataTop.actualMoneyCount }} </span>

                    </div>


                    <div style="display: flex;">
                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: rgb(150 233 149);
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 未课消次数：{{ dataTop.notNumCount }} </span>


                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #c2f54b;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 未课消金额：{{ dataTop.notMoneyCount }} </span>
                    </div>


                    <div style="display: flex;">
                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #5deb9e;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 预课消总次数：{{ dataTop.estimateNumCount }} </span>


                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #e39a59;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 预课消总金额: {{ dataTop.estimateMoneyCount }} </span>

                    </div>



                  </div>
                <div style="display: flex;width: 55%; flex-wrap: wrap;">
                    <div style="width: 100%;text-align: end;">
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-thumb" @click="exportBtnss">一键课消</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
                    </div>
                    <div style="width: 100%;display: flex;">
                      <div style="margin-left: 40%;width: 100px;">排序规则:</div>
                      <el-select  placeholder="请选择排序规则"  v-model="sortingRules" @change="changeSortingRules" style="width: 50%;"  clearable  filterable>
                        <el-option  v-for="item in sortingRulesArr"  :key="item.id"  :value="item.id"  :label="item.realname"> </el-option>
                      </el-select>
                    </div>
                </div>
              </div>
            </el-form-item>


            </el-form>



            <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataList" border height="700">
            <el-table-column prop="teacherName" label="教师姓名" ></el-table-column>
            <el-table-column prop="regionName" label="所在地域" width="100"></el-table-column>
            <el-table-column prop="totalSalesNum" label="实际课消次数" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(245, 140, 75);font-size: 25px;font-weight: 900;">{{scope.row.totalSalesNum}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="notNum" label="未课消次数" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(150, 233, 149);font-size: 25px;font-weight: 900;">{{scope.row.notNum}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="estimateNum" label="预课消总次数" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(93, 235, 158);font-size: 25px;font-weight: 900;">{{scope.row.estimateNum}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="allMoney" label="实际课消金额" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(209, 198, 51);font-size: 25px;font-weight: 900;">{{scope.row.allMoney}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="notMoney" label="未课消金额" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(194, 245, 75);font-size: 25px;font-weight: 900;">{{scope.row.notMoney}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="estimateMoney" label="预课消总金额" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(227, 154, 89);font-size: 25px;font-weight: 900;">{{scope.row.estimateMoney}}</span>
              </template> -->
            </el-table-column>
            <el-table-column header-align="center" label="查看详情" >
              <template slot-scope="scope">
                <el-button type="text" @click="details(scope.row)">详情</el-button>
              </template>
            </el-table-column>
            </el-table>



            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
            layout="prev, pager, next,sizes, jumper" :total="requestParameters.total">
            </el-pagination>


            <el-card v-if="ShowCourseSalesStatisticsDetails" style="position: fixed;width: 100%;top: 70px; height: 95vh;left: 0;z-index: 111; overflow-y: auto;">
              <CourseSalesStatisticsDetails :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButs" :isNewClassType="newClassType"></CourseSalesStatisticsDetails>
            </el-card>
      </el-tab-pane>
      <el-tab-pane label="学生统计" name="second">
        <el-form class="select">

          <!-- <el-form-item label="教师姓名:" label-width="100px" style="width: 30%;">
            <el-select
              placeholder="请选择"
              v-model="teacherName"
              style="width: 100%"
              clearable
              filterable
            >
              <el-option
                v-for="item in teacherArr"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
              >
              </el-option>
            </el-select>
          </el-form-item> -->


          <el-form-item label="线下学员:" label-width="100px" style="width: 30%;">
                <el-select
                  placeholder="请选择学员"
                  v-model="student"
                  style="width: 100%"
                  clearable
                  filterable
                  @change="studentChange"
                  :filter-method="handleInput"
                >
                  <el-option
                    v-for="item in getStudentsArrs"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname"
                  >
                  </el-option>
                </el-select>
          </el-form-item>

          <el-form-item label="规划学员:" label-width="100px" style="width: 30%;">
                <el-select
                  placeholder="请选择学员"
                  v-model="student_s"
                  style="width: 100%"
                  clearable
                  filterable
                  @change="studentChange1"
                  :filter-method="handleInput1"
                >
                  <el-option
                    v-for="item in getStudentsArr_ss"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname"
                  >
                  </el-option>
                </el-select>
          </el-form-item>



          <el-form-item label="课消次数:" label-width="100px" style="width: 30%;">
            <el-input
              placeholder="请输入课消次数"
              v-model="cancellationsNumber_s"
              :onkeyup="cancellationsNumber_s = cancellationsNumber_s.replace(/[\u4E00-\u9FA5]/g,'')"
              style="width: 100%"
              clearable
            ></el-input>
          </el-form-item>


          <el-form-item label="课消金额:" label-width="100px" style="width: 30%;">
            <el-input
              placeholder="请输入课消金额"
              v-model="cancellationsMoney_s"
              :onkeyup="cancellationsMoney_s = cancellationsMoney_s.replace(/[\u4E00-\u9FA5]/g,'')"
              style="width: 100%"
              clearable
            ></el-input>
          </el-form-item>



          <el-form-item label="所在地域:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择所在地域"
                v-model="regionName"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in optionsListt"
                  :key="item.id"
                  :value="item.dictType"
                  :label="item.dictValue"
                >
                </el-option>
              </el-select>
         </el-form-item>

         <el-form-item label="学生类型:" label-width="100px" style="width: 30%;">
              <el-select v-model="newClassType"  filterable placeholder="请选择学生类型"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in newClassTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
         </el-form-item>


         <el-form-item label="课程类别:" label-width="100px" style="width: 30%;">
              <el-select  placeholder="请选择课程类别"  v-model="courseCategoryIds" style="width: 100%"  clearable filterable >
                <el-option  v-for="item in categoryList"  :key="item.id"  :value="item.id" :label="item.categoryName"></el-option>
              </el-select>
         </el-form-item>

         <el-form-item label="日期:" label-width="100px" style="width: 50%;">
            <el-date-picker
            v-model="dateTimeList_s"
            type="daterange"
            value-format="yyyy-MM-dd"
            style="width: 100%;"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="渠道:" label-width="100px" style="width: 30%;">
              <el-select clearable filterable  style="width:100%;"  v-model="channelType" placeholder="请选择渠道">
                <el-option v-for="teacher in DealTypeListt" :key="teacher.value" :value="teacher.value" :label="teacher.label">
                </el-option>
              </el-select>
          </el-form-item>





          <el-form-item style="width: 100%;">
            <div style="display: flex;">
              <div style="width: 55%;">
                <div style="display: flex;">
                      <span
                      style="
                        font-weight: 900;

                        width: 400px;
                        background-color: #f58c4b;
                        height: 30px;
                        border-radius: 10px;
                        padding: 5px 0px;
                        margin-bottom: 10px;
                        text-align: start;
                        line-height: 26px;
                        padding-left: 10px;
                        margin-left: 100px;
                        padding-left: 17px;
                      "
                    > 实际课消次数:{{ dataTop_s.actualNumCount }} </span>

                    <span
                      style="
                        font-weight: 900;

                        width: 400px;
                        background-color: #d1c633;
                        height: 30px;
                        border-radius: 10px;
                        padding: 5px 0px;
                        margin-bottom: 10px;
                        text-align: start;
                        line-height: 26px;
                        padding-left: 10px;
                        margin-left: 100px;
                        padding-left: 17px;
                      "
                    > 实际课消金额:{{ dataTop_s.actualMoneyCount }} </span>

                    </div>


                    <div style="display: flex;">
                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: rgb(150 233 149);
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 未课消次数：{{ dataTop_s.notNumCount }} </span>


                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #c2f54b;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 未课消金额：{{ dataTop_s.notMoneyCount }} </span>
                    </div>


                    <div style="display: flex;">
                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #5deb9e;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 预课消总次数：{{ dataTop_s.estimateNumCount }} </span>


                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #e39a59;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 预课消总金额: {{ dataTop_s.estimateMoneyCount }} </span>

                    </div>



              </div>

              <div style="display: flex;width: 55%; flex-wrap: wrap;">
                    <div style="width: 100%;text-align: end;">
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-thumb" @click="exportBtnss">一键课消</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
                    </div>
                    <div style="width: 100%;display: flex;">
                      <div style="margin-left: 40%;width: 100px;">排序规则:</div>
                      <el-select  placeholder="请选择排序规则"  v-model="sortingRuless" @change="changeSortingRuless" style="width: 50%;"  clearable  filterable>
                        <el-option  v-for="item in sortingRulesArr"  :key="item.id"  :value="item.id"  :label="item.realname"> </el-option>
                      </el-select>
                    </div>
              </div>



            </div>
          </el-form-item>


          </el-form>



          <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataList_s" border height="700">
            <el-table-column prop="studentName" label="学生姓名" ></el-table-column>
            <el-table-column prop="regionName" label="所在地域" width="100"></el-table-column>
            <el-table-column prop="totalSalesNum" label="实际课消次数" >
                <!-- <template slot-scope="scope">
                  <span style="color:rgb(245, 140, 75);font-size: 25px;font-weight: 900;">{{scope.row.totalSalesNum}}</span>
                </template> -->
            </el-table-column>
            <el-table-column prop="notNum" label="未课消次数" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(150, 233, 149);font-size: 25px;font-weight: 900;">{{scope.row.notNum}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="estimateNum" label="预课消总次数" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(93, 235, 158);font-size: 25px;font-weight: 900;">{{scope.row.estimateNum}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="allMoney" label="实际课消金额" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(209, 198, 51);font-size: 25px;font-weight: 900;">{{scope.row.allMoney}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="notMoney" label="未课消金额" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(194, 245, 75);font-size: 25px;font-weight: 900;">{{scope.row.notMoney}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="estimateMoney" label="预课消总金额" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(227, 154, 89);font-size: 25px;font-weight: 900;">{{scope.row.estimateMoney}}</span>
              </template> -->
            </el-table-column>
          <el-table-column header-align="center" label="查看详情" >
            <template slot-scope="scope">
              <el-button type="text" @click="details_s(scope.row)">详情</el-button>
            </template>
          </el-table-column>
          </el-table>



          <el-pagination @size-change="handleSizeChange_s" @current-change="handleCurrentChange_s"
          :current-page="requestParameters_s.pageNum" :page-size="requestParameters_s.pageSize"
          layout="prev, pager, next,sizes, jumper" :total="requestParameters_s.total">
          </el-pagination>


          <el-card v-if="ShowCourseSalesStatisticsDetails_s" style="position: fixed;width: 100%;top: 70px; overflow-y: auto;height: 95vh;left: 0;z-index: 111; ">
            <CourseSalesStatisticsDetails_s :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButs" :isNewClassType="newClassType"></CourseSalesStatisticsDetails_s>
          </el-card>
      </el-tab-pane>

      <el-tab-pane label="实际课消统计" name="actualCourseConsumptionStatistics">

        <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
          <div class="glow-effect" style="width: 22%; height: 100px; border: 1px solid #0fb2f6;" @click="handleClickTab(1)">
            <div style="font-size: 25px;color: #18dec5; font-weight: 900; margin: 15px 0px 10px 0px;">{{ TotalAmountOfCourseCancellations }}</div>
            <div class="clickable-text">课程待消总额</div>
          </div>
          <div class="glow-effect" style="width: 22%;height: 100px; border: 1px solid #0fb2f6;" @click="handleClickTab(2)">
            <div style="font-size: 25px;color: #18dec5; font-weight: 900; margin: 15px 0px 10px 0px;">{{ TotalCourseHoursToBeCancelled }}</div>
            <div class="clickable-text">课程待消总课时</div>
          </div>
          <div class="glow-effect" style="width: 22%;height: 100px; border: 1px solid #0fb2f6;" @click="handleClickTab(3)">
            <div style="font-size: 25px;color: #18dec5; font-weight: 900; margin: 15px 0px 10px 0px;">{{ TodaysTotalAmountOfNewlyAddedClassExpenses }}</div>
            <div class="clickable-text">今日新增课消总额</div>
          </div>
          <div class="glow-effect" style="width: 22%;height: 100px; border: 1px solid #0fb2f6;" @click="handleClickTab(4)">
            <div style="font-size: 25px;color: #18dec5; font-weight: 900; margin: 15px 0px 10px 0px;">{{ TodaysNewlyAddedClassHours }}</div>
            <div class="clickable-text">今日新增课时数</div>
          </div>
        </div>

        <div style="margin-bottom: 20px;text-align: end;">
          <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-thumb" @click="handleOnekeyCourseConsumption">一键课消</el-button>
        </div>

        <el-table v-if="typeCourseConsumptionStatistics === 1"  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataListactualCourseConsumptionStatistics" border height="700">
            <el-table-column prop="studentName" header-align="center"  label="学生姓名" ></el-table-column>
            <el-table-column prop="moneySum" header-align="center"  label="总课消金额" ></el-table-column>
            <el-table-column prop="moneyResidue" header-align="center"  label="剩余总金额" ></el-table-column>
            <el-table-column prop="moneyYet" header-align="center"  label="已课消金额" ></el-table-column>
            <el-table-column header-align="center" label="操作" width="150px">
              <template slot-scope="scope">
                <el-button type="text" @click="details_s(scope.row)">详情</el-button>
              </template>
            </el-table-column>
        </el-table>


        <el-table v-if="typeCourseConsumptionStatistics === 2"  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataListactualCourseConsumptionStatistics" border height="700">
            <el-table-column prop="studentName" header-align="center"  label="学生姓名" ></el-table-column>
            <el-table-column prop="hourNumber" header-align="center"  label="学业课课时数" ></el-table-column>
            <el-table-column prop="familyHourResidue" header-align="center"  label="家庭教育课剩余课时数" ></el-table-column>
            <el-table-column prop="familyHourYet" header-align="center"  label="家庭教育课已课消课时数" ></el-table-column>
            <el-table-column prop="familyHourNumber" header-align="center"  label="家庭教育课课时数" ></el-table-column>
            <el-table-column prop="hourSum" header-align="center"  label="总课时数" ></el-table-column>
            <el-table-column prop="hourResidue" header-align="center"  label="学业剩余课时数" ></el-table-column>
            <el-table-column prop="hourYet" header-align="center"  label="学业已消课时数" ></el-table-column>
            <el-table-column header-align="center" label="操作" width="150px">
              <template slot-scope="scope">
                <el-button type="text" @click="details_s(scope.row)">详情</el-button>
              </template>
            </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChangealCourseConsumptionStatistics" @current-change="handleCurrentChangealCourseConsumptionStatistics"
          :current-page="requestParametersalCourseConsumptionStatistics.pageNum" :page-size="requestParametersalCourseConsumptionStatistics.pageSize"
          layout="prev, pager, next,sizes, jumper" :total="requestParametersalCourseConsumptionStatistics.total"> </el-pagination>


        <el-card v-if="ShowCourseSalesStatisticsDetails_s" style="position: fixed;width: 100%;top: 70px; height: 95%;left: 0;z-index: 111;overflow: auto;">
          <CourseSalesStatisticsDetails_s :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButs"></CourseSalesStatisticsDetails_s>
        </el-card>

      </el-tab-pane>


      <el-tab-pane label="赠送统计" name="GiftStatistics">
        <el-form class="select">

            <el-form-item label="线下学员:" label-width="100px" style="width: 30%;">
                  <el-select
                    placeholder="请选择学员"
                    v-model="student1"
                    style="width: 100%"
                    clearable
                    filterable
                    @change="studentChange222"
                    :filter-method="handleInput222"
                  >
                    <el-option
                      v-for="item in getStudentsArr"
                      :key="item.id"
                      :value="item.id"
                      :label="item.realname"
                    >
                    </el-option>
                  </el-select>
            </el-form-item>

            <el-form-item label="规划学员:" label-width="100px" style="width: 30%;">
                  <el-select
                    placeholder="请选择学员"
                    v-model="student_s1"
                    style="width: 100%"
                    clearable
                    filterable
                    @change="studentChange22"
                    :filter-method="handleInput22"
                  >
                    <el-option
                      v-for="item in getStudentsArr_s"
                      :key="item.id"
                      :value="item.id"
                      :label="item.realname"
                    >
                    </el-option>
                  </el-select>
            </el-form-item>


            <el-form-item label="课消次数:" label-width="100px" style="width: 30%;">
              <el-input
                placeholder="请输入课消次数"
                v-model="cancellationsNumber1"
                :onkeyup="cancellationsNumber1 = cancellationsNumber1.replace(/[\u4E00-\u9FA5]/g,'')"
                style="width: 100%"
                clearable
              ></el-input>
            </el-form-item>

<!-- 
            <el-form-item label="课消金额:" label-width="100px" style="width: 30%;">
              <el-input
                placeholder="请输入课消金额"
                v-model="cancellationsMoney1"
                :onkeyup="cancellationsMoney1 = cancellationsMoney1.replace(/[\u4E00-\u9FA5]/g,'')"
                style="width: 100%"
                clearable
              ></el-input>
            </el-form-item> -->


            <el-form-item label="学生类型:" label-width="100px" style="width: 30%;">
              <el-select v-model="newClassType1"  filterable placeholder="请选择学生类型"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in newClassTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="所在地域:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择所在地域"
                v-model="regionName1"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in optionsListt"
                  :key="item.id"
                  :value="item.dictType"
                  :label="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="课程类别:" label-width="100px" style="width: 30%;">
              <el-select  placeholder="请选择课程类别"  v-model="courseCategoryIds" style="width: 100%"  clearable filterable >
                <el-option  v-for="item in categoryList"  :key="item.id"  :value="item.id" :label="item.categoryName"></el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="日期:" label-width="100px" style="width: 50%;text-align: justify;">
              <el-date-picker
                v-model="dateTimeList1"
                type="daterange"
                style="width: 100%;"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="渠道:" label-width="100px" style="width: 30%;">
              <el-select clearable filterable  style="width:100%;"  v-model="channelType" placeholder="请选择渠道">
                <el-option v-for="teacher in DealTypeListt" :key="teacher.value" :value="teacher.value" :label="teacher.label">
                </el-option>
              </el-select>
            </el-form-item>

                

            <el-form-item style="width: 100%;">
              <div style="display: flex;">
                <div style="width: 55%;">
                    <div style="display: flex;">
                      <span  style="  font-weight: 900;   width: 400px;  background-color: #f58c4b;  height: 30px;  border-radius: 10px;  padding: 5px 0px;   margin-bottom: 10px; text-align: start;  line-height: 26px;  padding-left: 10px;  margin-left: 100px;  padding-left: 17px;  "> 赠送课消次数:{{ actualNumCountAll }} </span>
                    </div>
                  </div>
                <div style="display: flex;width: 55%; flex-wrap: wrap;">
                    <div style="width: 100%;text-align: end;">
                      <!-- <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-thumb" @click="exportBtnss">一键课消</el-button> -->
                      <!-- <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button> -->
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns1">搜索</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns1">清空</el-button>
                    </div>
                </div>
              </div>
            </el-form-item>

            </el-form>

            <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataList1" border height="700">
              <el-table-column prop="studentName" label="学生姓名" ></el-table-column>
              <el-table-column prop="regionName" label="所在地域" width="100"></el-table-column>
              <el-table-column prop="totalGiveNum" label="赠送实际课消次数" width="150"></el-table-column>
              <el-table-column prop="allMoney" label="赠送实际课消金额" width="150"></el-table-column>
              <el-table-column header-align="center" label="查看详情" >
                <template slot-scope="scope">
                  <el-button type="text" @click="details1(scope.row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
            :current-page="requestParameters1.pageNum" :page-size="requestParameters1.pageSize"
            layout="prev, pager, next,sizes, jumper" :total="requestParameters1.total">
            </el-pagination>

            <el-card v-if="ShowCourseSalesStatisticsDetails_s" style="position: fixed;width: 100%;top: 70px; height: 95vh;left: 0;z-index: 111; overflow-y: auto;">
               <CourseSalesStatisticsDetailsCopyCopy :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButs" :isNewClassType="newClassType1"></CourseSalesStatisticsDetailsCopyCopy>
            </el-card>
      </el-tab-pane>


      <el-tab-pane label="销售统计" name="SalesStatistics">
        <el-form class="select">

            <el-form-item label="销售姓名:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择"
                v-model="teacherName11"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in teacherArrs"
                  :key="item.saleId"
                  :value="item.saleId"
                  :label="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="课消次数:" label-width="100px" style="width: 30%;">
              <el-input
                placeholder="请输入课消次数"
                v-model="cancellationsNumber11"
                :onkeyup="cancellationsNumber11 = cancellationsNumber11.replace(/[\u4E00-\u9FA5]/g,'')"
                style="width: 100%"
                clearable
              ></el-input>
            </el-form-item>


            <el-form-item label="课消金额:" label-width="100px" style="width: 30%;">
              <el-input
                placeholder="请输入课消金额"
                v-model="cancellationsMoney11"
                :onkeyup="cancellationsMoney11 = cancellationsMoney11.replace(/[\u4E00-\u9FA5]/g,'')"
                style="width: 100%"
                clearable
              ></el-input>
            </el-form-item>


            <el-form-item label="学生类型:" label-width="100px" style="width: 30%;">
              <el-select v-model="newClassType11"  filterable placeholder="请选择学生类型"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in newClassTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="所在地域:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择所在地域"
                v-model="regionName11"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in optionsListt"
                  :key="item.id"
                  :value="item.dictType"
                  :label="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="课程类别:" label-width="100px" style="width: 30%;">
              <el-select  placeholder="请选择课程类别"  v-model="courseCategoryIds" style="width: 100%"  clearable filterable >
                <el-option  v-for="item in categoryList"  :key="item.id"  :value="item.id" :label="item.categoryName"></el-option>
              </el-select>
            </el-form-item>



            <el-form-item label="日期:" label-width="100px" style="width: 50%;text-align: justify;">
              <el-date-picker
                v-model="dateTimeList11"
                type="daterange"
                style="width: 100%;"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="渠道:" label-width="100px" style="width: 30%;">
              <el-select clearable filterable  style="width:100%;"  v-model="channelType" placeholder="请选择渠道">
                <el-option v-for="teacher in DealTypeListt" :key="teacher.value" :value="teacher.value" :label="teacher.label">
                </el-option>
              </el-select>
            </el-form-item>




            <el-form-item style="width: 100%;">
              <div style="display: flex;">
                <div style="width: 55%;">

                    <div style="display: flex;">
                      <span
                      style="
                        font-weight: 900;

                        width: 400px;
                        background-color: #f58c4b;
                        height: 30px;
                        border-radius: 10px;
                        padding: 5px 0px;
                        margin-bottom: 10px;
                        text-align: start;
                        line-height: 26px;
                        padding-left: 10px;
                        margin-left: 100px;
                        padding-left: 17px;
                      "
                    > 实际课消次数:{{ dataTop11.actualNumCount }} </span>

                    <span
                      style="
                        font-weight: 900;

                        width: 400px;
                        background-color: #d1c633;
                        height: 30px;
                        border-radius: 10px;
                        padding: 5px 0px;
                        margin-bottom: 10px;
                        text-align: start;
                        line-height: 26px;
                        padding-left: 10px;
                        margin-left: 100px;
                        padding-left: 17px;
                      "
                    > 实际课消金额:{{ dataTop11.actualMoneyCount }} </span>

                    </div>


                    <div style="display: flex;">
                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: rgb(150 233 149);
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 未课消次数：{{ dataTop11.notNumCount }} </span>


                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #c2f54b;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 未课消金额：{{ dataTop11.notMoneyCount }} </span>
                    </div>


                    <div style="display: flex;">
                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #5deb9e;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 预课消总次数：{{ dataTop11.estimateNumCount }} </span>


                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #e39a59;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 预课消总金额: {{ dataTop11.estimateMoneyCount }} </span>

                    </div>



                  </div>
                <div style="display: flex;width: 55%; flex-wrap: wrap;">
                    <div style="width: 100%;text-align: end;">
                      <!-- <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-thumb" @click="exportBtnss11">一键课消</el-button> -->
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns11">导出</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns11">搜索</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns11">清空</el-button>
                    </div>
                    <div style="width: 100%;display: flex;">
                      <div style="margin-left: 40%;width: 100px;">排序规则:</div>
                      <el-select  placeholder="请选择排序规则"  v-model="sortingRules11" @change="changeSortingRules11" style="width: 50%;"  clearable  filterable>
                        <el-option  v-for="item in sortingRulesArr"  :key="item.id"  :value="item.id"  :label="item.realname"> </el-option>
                      </el-select>
                    </div>
                </div>
              </div>
            </el-form-item>


            </el-form>



            <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataList11" border height="700">
            <el-table-column prop="teacherName" label="销售" ></el-table-column>
            <el-table-column prop="regionName" label="所在地域" width="100"></el-table-column>
            <el-table-column prop="totalSalesNum" label="实际课消次数" width="130">
            </el-table-column>
            <el-table-column prop="notNum" label="未课消次数" width="130">
            </el-table-column>
            <el-table-column prop="estimateNum" label="预课消总次数" width="130">
            </el-table-column>
            <el-table-column prop="allMoney" label="实际课消金额" width="130">
            </el-table-column>
            <el-table-column prop="notMoney" label="未课消金额" width="130">
            </el-table-column>
            <el-table-column prop="estimateMoney" label="预课消总金额" width="130">
            </el-table-column>
            <el-table-column header-align="center" label="查看详情" >
              <template slot-scope="scope">
                <el-button type="text" @click="detailss11(scope.row)">详情</el-button>
              </template>
            </el-table-column>
            </el-table>



            <el-pagination @size-change="handleSizeChange11" @current-change="handleCurrentChange11"
            :current-page="requestParameters11.pageNum" :page-size="requestParameters11.pageSize"
            layout="prev, pager, next,sizes, jumper" :total="requestParameters11.total">
            </el-pagination>


            <el-card v-if="ShowCourseSalesStatisticsDetails" style="position: fixed;width: 100%;top: 70px; height: 95vh;left: 0;z-index: 111; overflow-y: auto;">
              <CourseSalesStatisticsDetailsCopy :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButs" :isNewClassType="newClassType11"></CourseSalesStatisticsDetailsCopy>
            </el-card>
      </el-tab-pane>


      <el-tab-pane label="诊断师统计" name="DiagnosticStatistics">
        <el-form class="select">

            <el-form-item label="诊断师姓名:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择"
                v-model="teacherName11"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in teacherArrss"
                  :key="item.teacherId"
                  :value="item.teacherId"
                  :label="item.teacherName"
                >
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="课消次数:" label-width="100px" style="width: 30%;">
              <el-input
                placeholder="请输入课消次数"
                v-model="cancellationsNumber11"
                :onkeyup="cancellationsNumber11 = cancellationsNumber11.replace(/[\u4E00-\u9FA5]/g,'')"
                style="width: 100%"
                clearable
              ></el-input>
            </el-form-item>


            <el-form-item label="课消金额:" label-width="100px" style="width: 30%;">
              <el-input
                placeholder="请输入课消金额"
                v-model="cancellationsMoney11"
                :onkeyup="cancellationsMoney11 = cancellationsMoney11.replace(/[\u4E00-\u9FA5]/g,'')"
                style="width: 100%"
                clearable
              ></el-input>
            </el-form-item>


            <el-form-item label="学生类型:" label-width="100px" style="width: 30%;">
              <el-select v-model="newClassType11"  filterable placeholder="请选择学生类型"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in newClassTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="所在地域:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择所在地域"
                v-model="regionName11"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in optionsListt"
                  :key="item.id"
                  :value="item.dictType"
                  :label="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="课程类别:" label-width="100px" style="width: 30%;">
              <el-select  placeholder="请选择课程类别"  v-model="courseCategoryIds" style="width: 100%"  clearable filterable >
                <el-option  v-for="item in categoryList"  :key="item.id"  :value="item.id" :label="item.categoryName"></el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="日期:" label-width="100px" style="width: 50%;text-align: justify;">
              <el-date-picker
                v-model="dateTimeList11"
                type="daterange"
                style="width: 100%;"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>


            <el-form-item label="渠道:" label-width="100px" style="width: 30%;">
              <el-select clearable filterable  style="width:100%;"  v-model="channelType" placeholder="请选择渠道">
                <el-option v-for="teacher in DealTypeListt" :key="teacher.value" :value="teacher.value" :label="teacher.label">
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item style="width: 100%;">
              <div style="display: flex;">
                <div style="width: 55%;">

                    <div style="display: flex;">
                      <span
                      style="
                        font-weight: 900;

                        width: 400px;
                        background-color: #f58c4b;
                        height: 30px;
                        border-radius: 10px;
                        padding: 5px 0px;
                        margin-bottom: 10px;
                        text-align: start;
                        line-height: 26px;
                        padding-left: 10px;
                        margin-left: 100px;
                        padding-left: 17px;
                      "
                    > 实际课消次数:{{ dataTop11.actualNumCount }} </span>

                    <span
                      style="
                        font-weight: 900;

                        width: 400px;
                        background-color: #d1c633;
                        height: 30px;
                        border-radius: 10px;
                        padding: 5px 0px;
                        margin-bottom: 10px;
                        text-align: start;
                        line-height: 26px;
                        padding-left: 10px;
                        margin-left: 100px;
                        padding-left: 17px;
                      "
                    > 实际课消金额:{{ dataTop11.actualMoneyCount }} </span>

                    </div>


                    <div style="display: flex;">
                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: rgb(150 233 149);
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 未课消次数：{{ dataTop11.notNumCount }} </span>


                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #c2f54b;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 未课消金额：{{ dataTop11.notMoneyCount }} </span>
                    </div>


                    <div style="display: flex;">
                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #5deb9e;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 预课消总次数：{{ dataTop11.estimateNumCount }} </span>


                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #e39a59;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 预课消总金额: {{ dataTop11.estimateMoneyCount }} </span>

                    </div>



                  </div>
                <div style="display: flex;width: 55%; flex-wrap: wrap;">
                    <div style="width: 100%;text-align: end;">
                      <!-- <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-thumb" @click="exportBtnss11">一键课消</el-button> -->
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns11">导出</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns11">搜索</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns11">清空</el-button>
                    </div>
                    <div style="width: 100%;display: flex;">
                      <div style="margin-left: 40%;width: 100px;">排序规则:</div>
                      <el-select  placeholder="请选择排序规则"  v-model="sortingRules11" @change="changeSortingRules11" style="width: 50%;"  clearable  filterable>
                        <el-option  v-for="item in sortingRulesArr"  :key="item.id"  :value="item.id"  :label="item.realname"> </el-option>
                      </el-select>
                    </div>
                </div>
              </div>
            </el-form-item>


            </el-form>



            <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataList11" border height="700">
            <el-table-column prop="teacherName" label="诊断师" ></el-table-column>
            <el-table-column prop="regionName" label="所在地域" width="100"></el-table-column>
            <el-table-column prop="totalSalesNum" label="实际课消次数" width="130">
            </el-table-column>
            <el-table-column prop="notNum" label="未课消次数" width="130">
            </el-table-column>
            <el-table-column prop="estimateNum" label="预课消总次数" width="130">
            </el-table-column>
            <el-table-column prop="allMoney" label="实际课消金额" width="130">
            </el-table-column>
            <el-table-column prop="notMoney" label="未课消金额" width="130">
            </el-table-column>
            <el-table-column prop="estimateMoney" label="预课消总金额" width="130">
            </el-table-column>
            <el-table-column header-align="center" label="查看详情" >
              <template slot-scope="scope">
                <el-button type="text" @click="detailss11(scope.row)">详情</el-button>
              </template>
            </el-table-column>
            </el-table>



            <el-pagination @size-change="handleSizeChange11" @current-change="handleCurrentChange11"
            :current-page="requestParameters11.pageNum" :page-size="requestParameters11.pageSize"
            layout="prev, pager, next,sizes, jumper" :total="requestParameters11.total">
            </el-pagination>


            <el-card v-if="ShowCourseSalesStatisticsDetails" style="position: fixed;width: 100%;top: 70px; height: 95vh;left: 0;z-index: 111; overflow-y: auto;">
              <CourseSalesStatisticsDetailsCopy :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButs" :isNewClassType="newClassType11"></CourseSalesStatisticsDetailsCopy>
            </el-card>
      </el-tab-pane>


      <el-tab-pane label="规划师统计" name="PlannerStatistics">
        <el-form class="select">

            <el-form-item label="规划师姓名:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择"
                v-model="teacherName11"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in teacherArrsss"
                  :key="item.teacherId"
                  :value="item.teacherId"
                  :label="item.teacherName"
                >
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="课消次数:" label-width="100px" style="width: 30%;">
              <el-input
                placeholder="请输入课消次数"
                v-model="cancellationsNumber11"
                :onkeyup="cancellationsNumber11 = cancellationsNumber11.replace(/[\u4E00-\u9FA5]/g,'')"
                style="width: 100%"
                clearable
              ></el-input>
            </el-form-item>


            <el-form-item label="课消金额:" label-width="100px" style="width: 30%;">
              <el-input
                placeholder="请输入课消金额"
                v-model="cancellationsMoney11"
                :onkeyup="cancellationsMoney11 = cancellationsMoney11.replace(/[\u4E00-\u9FA5]/g,'')"
                style="width: 100%"
                clearable
              ></el-input>
            </el-form-item>


            <el-form-item label="学生类型:" label-width="100px" style="width: 30%;">
              <el-select v-model="newClassType11"  filterable placeholder="请选择学生类型"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in newClassTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="所在地域:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择所在地域"
                v-model="regionName11"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in optionsListt"
                  :key="item.id"
                  :value="item.dictType"
                  :label="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="课程类别:" label-width="100px" style="width: 30%;">
              <el-select  placeholder="请选择课程类别"  v-model="courseCategoryIds" style="width: 100%"  clearable filterable >
                <el-option  v-for="item in categoryList"  :key="item.id"  :value="item.id" :label="item.categoryName"></el-option>
              </el-select>
            </el-form-item>



            <el-form-item label="日期:" label-width="100px" style="width: 50%;text-align: justify;">
              <el-date-picker
                v-model="dateTimeList11"
                type="daterange"
                style="width: 100%;"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="渠道:" label-width="100px" style="width: 30%;">
              <el-select clearable filterable  style="width:100%;"  v-model="channelType" placeholder="请选择渠道">
                <el-option v-for="teacher in DealTypeListt" :key="teacher.value" :value="teacher.value" :label="teacher.label">
                </el-option>
              </el-select>
            </el-form-item>




            <el-form-item style="width: 100%;">
              <div style="display: flex;">
                <div style="width: 55%;">

                    <div style="display: flex;">
                      <span
                      style="
                        font-weight: 900;

                        width: 400px;
                        background-color: #f58c4b;
                        height: 30px;
                        border-radius: 10px;
                        padding: 5px 0px;
                        margin-bottom: 10px;
                        text-align: start;
                        line-height: 26px;
                        padding-left: 10px;
                        margin-left: 100px;
                        padding-left: 17px;
                      "
                    > 实际课消次数:{{ dataTop11.actualNumCount }} </span>

                    <span
                      style="
                        font-weight: 900;

                        width: 400px;
                        background-color: #d1c633;
                        height: 30px;
                        border-radius: 10px;
                        padding: 5px 0px;
                        margin-bottom: 10px;
                        text-align: start;
                        line-height: 26px;
                        padding-left: 10px;
                        margin-left: 100px;
                        padding-left: 17px;
                      "
                    > 实际课消金额:{{ dataTop11.actualMoneyCount }} </span>

                    </div>


                    <div style="display: flex;">
                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: rgb(150 233 149);
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 未课消次数：{{ dataTop11.notNumCount }} </span>


                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #c2f54b;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 未课消金额：{{ dataTop11.notMoneyCount }} </span>
                    </div>


                    <div style="display: flex;">
                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #5deb9e;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 预课消总次数：{{ dataTop11.estimateNumCount }} </span>


                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #e39a59;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 预课消总金额: {{ dataTop11.estimateMoneyCount }} </span>

                    </div>



                  </div>
                <div style="display: flex;width: 55%; flex-wrap: wrap;">
                    <div style="width: 100%;text-align: end;">
                      <!-- <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-thumb" @click="exportBtnss11">一键课消</el-button> -->
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns11">导出</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns11">搜索</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns11">清空</el-button>
                    </div>
                    <div style="width: 100%;display: flex;">
                      <div style="margin-left: 40%;width: 100px;">排序规则:</div>
                      <el-select  placeholder="请选择排序规则"  v-model="sortingRules11" @change="changeSortingRules11" style="width: 50%;"  clearable  filterable>
                        <el-option  v-for="item in sortingRulesArr"  :key="item.id"  :value="item.id"  :label="item.realname"> </el-option>
                      </el-select>
                    </div>
                </div>
              </div>
            </el-form-item>


            </el-form>



            <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataList11" border height="700">
            <el-table-column prop="teacherName" label="规划师" ></el-table-column>
            <el-table-column prop="regionName" label="所在地域" width="100"></el-table-column>
            <el-table-column prop="totalSalesNum" label="实际课消次数" width="130">
            </el-table-column>
            <el-table-column prop="notNum" label="未课消次数" width="130">
            </el-table-column>
            <el-table-column prop="estimateNum" label="预课消总次数" width="130">
            </el-table-column>
            <el-table-column prop="allMoney" label="实际课消金额" width="130">
            </el-table-column>
            <el-table-column prop="notMoney" label="未课消金额" width="130">
            </el-table-column>
            <el-table-column prop="estimateMoney" label="预课消总金额" width="130">
            </el-table-column>
            <el-table-column header-align="center" label="查看详情" >
              <template slot-scope="scope">
                <el-button type="text" @click="detailss11(scope.row)">详情</el-button>
              </template>
            </el-table-column>
            </el-table>



            <el-pagination @size-change="handleSizeChange11" @current-change="handleCurrentChange11"
            :current-page="requestParameters11.pageNum" :page-size="requestParameters11.pageSize"
            layout="prev, pager, next,sizes, jumper" :total="requestParameters11.total">
            </el-pagination>


            <el-card v-if="ShowCourseSalesStatisticsDetails" style="position: fixed;width: 100%;top: 70px; height: 95vh;left: 0;z-index: 111; overflow-y: auto;">
              <CourseSalesStatisticsDetailsCopy :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButs" :isNewClassType="newClassType11"></CourseSalesStatisticsDetailsCopy>
            </el-card>
      </el-tab-pane>


      <el-tab-pane label="学科组统计" name="SubjectGroupStatistics">
        <el-form class="select">

            <el-form-item label="学科组:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择"
                v-model="SubjectGroup"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in SubjectGroupList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.teacherName"
                >
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="课消次数:" label-width="100px" style="width: 30%;">
              <el-input
                placeholder="请输入课消次数"
                v-model="cancellationsNumber"
                :onkeyup="cancellationsNumber = cancellationsNumber.replace(/[\u4E00-\u9FA5]/g,'')"
                style="width: 100%"
                clearable
              ></el-input>
            </el-form-item>


            <el-form-item label="课消金额:" label-width="100px" style="width: 30%;">
              <el-input
                placeholder="请输入课消金额"
                v-model="cancellationsMoney"
                :onkeyup="cancellationsMoney = cancellationsMoney.replace(/[\u4E00-\u9FA5]/g,'')"
                style="width: 100%"
                clearable
              ></el-input>
            </el-form-item>


            <el-form-item label="学生类型:" label-width="100px" style="width: 30%;">
              <el-select v-model="newClassType"  filterable placeholder="请选择学生类型"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in newClassTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="所在地域:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择所在地域"
                v-model="regionName"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in optionsListt"
                  :key="item.id"
                  :value="item.dictType"
                  :label="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="课程类别:" label-width="100px" style="width: 30%;">
              <el-select  placeholder="请选择课程类别"  v-model="courseCategoryIds" style="width: 100%"  clearable filterable >
                <el-option  v-for="item in categoryList"  :key="item.id"  :value="item.id" :label="item.categoryName"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="日期:" label-width="100px" style="width: 50%;text-align: justify;">
              <el-date-picker
                v-model="dateTimeList"
                type="daterange"
                style="width: 100%;"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="渠道:" label-width="100px" style="width: 30%;">
              <el-select clearable filterable  style="width:100%;"  v-model="channelType" placeholder="请选择渠道">
                <el-option v-for="teacher in DealTypeListt" :key="teacher.value" :value="teacher.value" :label="teacher.label">
                </el-option>
              </el-select>
            </el-form-item>




            <el-form-item style="width: 100%;">
              <div style="display: flex;">
                <div style="width: 55%;">

                    <div style="display: flex;">
                      <span
                      style="
                        font-weight: 900;

                        width: 400px;
                        background-color: #f58c4b;
                        height: 30px;
                        border-radius: 10px;
                        padding: 5px 0px;
                        margin-bottom: 10px;
                        text-align: start;
                        line-height: 26px;
                        padding-left: 10px;
                        margin-left: 100px;
                        padding-left: 17px;
                      "
                    > 实际课消次数:{{ dataTop.actualNumCount }} </span>

                    <span
                      style="
                        font-weight: 900;

                        width: 400px;
                        background-color: #d1c633;
                        height: 30px;
                        border-radius: 10px;
                        padding: 5px 0px;
                        margin-bottom: 10px;
                        text-align: start;
                        line-height: 26px;
                        padding-left: 10px;
                        margin-left: 100px;
                        padding-left: 17px;
                      "
                    > 实际课消金额:{{ dataTop.actualMoneyCount }} </span>

                    </div>


                    <div style="display: flex;">
                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: rgb(150 233 149);
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 未课消次数：{{ dataTop.notNumCount }} </span>


                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #c2f54b;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 未课消金额：{{ dataTop.notMoneyCount }} </span>
                    </div>


                    <div style="display: flex;">
                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #5deb9e;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 预课消总次数：{{ dataTop.estimateNumCount }} </span>


                      <span
                        style="
                          font-weight: 900;

                          width: 400px;
                          background-color: #e39a59;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 预课消总金额: {{ dataTop.estimateMoneyCount }} </span>

                    </div>



                  </div>
                <div style="display: flex;width: 55%; flex-wrap: wrap;">
                    <div style="width: 100%;text-align: end;">
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-thumb" @click="exportBtnss">一键课消</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns111">搜索</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="handleClerss111">清空</el-button>
                    </div>
                    <div style="width: 100%;display: flex;">
                      <div style="margin-left: 40%;width: 100px;">排序规则:</div>
                      <el-select  placeholder="请选择排序规则"  v-model="sortingRules" @change="changeSortingRules" style="width: 50%;"  clearable  filterable>
                        <el-option  v-for="item in sortingRulesArr"  :key="item.id"  :value="item.id"  :label="item.realname"> </el-option>
                      </el-select>
                    </div>
                </div>
              </div>
            </el-form-item>


            </el-form>



            <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataList1111" border height="700">
            <el-table-column prop="subjectGroupName" label="学科组" ></el-table-column>
            <el-table-column prop="manageName" label="学管姓名" width="100"></el-table-column>
            <el-table-column prop="totalSalesNum" label="总课销次数" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(245, 140, 75);font-size: 25px;font-weight: 900;">{{scope.row.totalSalesNum}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="allMoney" label="总课消金额" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(150, 233, 149);font-size: 25px;font-weight: 900;">{{scope.row.notNum}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="notNum" label="未课消总次数" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(93, 235, 158);font-size: 25px;font-weight: 900;">{{scope.row.estimateNum}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="notMoney" label="未课消总金额" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(209, 198, 51);font-size: 25px;font-weight: 900;">{{scope.row.allMoney}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="estimateNum" label="预计课消总次数" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(194, 245, 75);font-size: 25px;font-weight: 900;">{{scope.row.notMoney}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="estimateMoney" label="预计课消总金额" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(227, 154, 89);font-size: 25px;font-weight: 900;">{{scope.row.estimateMoney}}</span>
              </template> -->
            </el-table-column>
            <el-table-column header-align="center" label="查看详情" >
              <template slot-scope="scope">
                <el-button type="text" @click="details(scope.row)">详情</el-button>
              </template>
            </el-table-column>
            </el-table>



            <el-pagination @size-change="handleSizeChangessss" @current-change="handleCurrentChangesss"
            :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
            layout="prev, pager, next,sizes, jumper" :total="requestParameters.total">
            </el-pagination>


            <el-card v-if="ShowCourseSalesStatisticsDetails" style="position: fixed;width: 100%;top: 70px; height: 95vh;left: 0;z-index: 111; overflow-y: auto;">
              <CourseSalesStatisticsDetails_copy :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButss" :isNewClassType="newClassType"></CourseSalesStatisticsDetails_copy>
            </el-card>
       </el-tab-pane>


    </el-tabs>




  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
import CourseSalesStatisticsDetails from './CourseSalesStatisticsDetails.vue'
import CourseSalesStatisticsDetails_copy from './CourseSalesStatisticsDetails_copy.vue'
import CourseSalesStatisticsDetailsCopy from './CourseSalesStatisticsDetailsCopy.vue'
import CourseSalesStatisticsDetailsCopyCopy from './CourseSalesStatisticsDetailsCopyCopy.vue'

import CourseSalesStatisticsDetails_s from './CourseSalesStatisticsDetails_s.vue'
import { getTeachers_s,  getTeachers_sss, getTeachers_ssss,getStudentscopy } from "@/api/firstClassApi";
import {  getStudentsType, getcategoryList } from "@/api/fiveClassApi"
import Vue from 'vue';
import { ref, reactive, onMounted, getCurrentInstance, nextTick, onUpdated  } from '@vue/composition-api'
var $Vue = Vue.prototype
import { useStore } from '../../pinia/stores.js'
import { Loading } from 'element-ui';



export default {
  components:{
    CourseSalesStatisticsDetails_copy,
    CourseSalesStatisticsDetails,
    CourseSalesStatisticsDetails_s,
    CourseSalesStatisticsDetailsCopy,
    CourseSalesStatisticsDetailsCopyCopy,
  },

  setup(props, { root, refs }) {

    let newClassType =  ref('')
    let newClassTypeList = ref([
      {id:1,name:'规划'},
      {id:2,name:'线下'},
      {id:3,name:'纯补课'},
    ])


    // 获取当前日期
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // 月份从0开始

    // 补零函数
    function pad(n) {
      return n < 10 ? '0' + n : n;
    }

    // 当前月第一天
    const firstDay = `${year}-${pad(month)}-01`;
    // 当前月最后一天
    const lastDay = new Date(year, month, 0).getDate();
    const currentDay = `${year}-${pad(month)}-${pad(lastDay)}`;

    let activeName =  ref('first')
    let getStudentsArr = ref([])
    let getStudentsArrs = ref([])
    let getStudentsArr_s = ref([])
    let getStudentsArr_ss = ref([])
    let student_s = ref("")
    let student = ref("")
    let requestParameters = reactive({ pageSize: 10, pageNum: 1,  total: 0,})
    let dateTimeList = ref([firstDay, currentDay]);
    let dateTimeList_s = ref([firstDay, currentDay]);
    let teacherName = ref("")
    let cancellationsNumber_s = ref("")
    let cancellationsMoney_s = ref("")
    let cancellationsNumber = ref("")
    let cancellationsMoney = ref("")
    let dataList = ref([])
    let dataList_s = ref([])
    let teacherArr = ref([])
    let teacherArrs = ref([])

    let teacherArrsss = ref([])
    let teacherArrss = ref([])

  
    let courseCategoryIds = ref("")
    let categoryList = ref([])
    let propsCategory = reactive({
          label: "categoryName",
          children: "children",
          value: "id"
    })

    let dataList1111 = ref([])
    let DealTypeListt = ref([ {
          value: 1,
          label: "线上",
        },
        {
          value: 2,
          label: "线下",
        },
        {
          value: 3,
          label: "转介绍",
        },])

    let channelType = ref('')

    let ShowCourseSalesStatisticsDetails = ref(false)
    let ShowCourseSalesStatisticsDetails_s = ref(false)
    let DetailsRow = reactive({})
    let TimeList = ref([])
    let typeCourseConsumptionStatistics = ref(1)
    let dataTop = reactive({ actualNumCount: 0, actualMoneyCount: 0,  notNumCount: 0,  notMoneyCount: 0, estimateNumCount: 0, estimateMoneyCount: 0})
    let dataTop_s = reactive({ actualNumCount: 0, actualMoneyCount: 0,  notNumCount: 0,  notMoneyCount: 0, estimateNumCount: 0, estimateMoneyCount: 0})
    let requestParameters_s = reactive({ pageSize: 10, pageNum: 1,  total: 0,})
    let requestType = ref('')

    const instance = getCurrentInstance()
    let dataListactualCourseConsumptionStatistics = ref([])
    let requestParametersalCourseConsumptionStatistics = reactive({ pageSize: 10, pageNum: 1,  total: 0,})

    let TotalAmountOfCourseCancellations = ref(0)
    let TotalCourseHoursToBeCancelled = ref(0)
    let TodaysTotalAmountOfNewlyAddedClassExpenses = ref(0)
    let TodaysNewlyAddedClassHours = ref(0)


    let actualNumCountAll = ref(0)

    let sortingRules = ref(1)
    let sortingRulesArr = ref([{ id:1, realname:'按实际课消金额排序'},{id:2, realname:'按预课消金额排序'}])
    let sortingRuless = ref(1)

    let regionName = ref('')
    let optionsListt = ref([
        {dictValue:"北京", dictType:1 },
        {dictValue:"深圳", dictType:2 },
      ])


    let student_s1 = ref("")
    let student1 = ref("")
    let cancellationsNumber1 = ref("")
    let cancellationsMoney1 = ref("")
    let newClassType1 = ref("")
    let regionName1 = ref("")
    let dateTimeList1 = ref([firstDay, currentDay]);
    let requestParameters1 = reactive({ pageSize: 10, pageNum: 1,  total: 0,})
    let dataList1 = ref([])


    let teacherName11 = ref("")
    let cancellationsNumber11 = ref("")
    let cancellationsMoney11 = ref("")
    let newClassType11 = ref("")
    let regionName11 = ref("")
    let dateTimeList11 = ref([firstDay, currentDay]);
    let requestParameters11 = reactive({ pageSize: 10, pageNum: 1,  total: 0,})
    let dataList11 = ref([])
    let dataTop11 = reactive({ actualNumCount: 0, actualMoneyCount: 0,  notNumCount: 0,  notMoneyCount: 0, estimateNumCount: 0, estimateMoneyCount: 0})
    let sortingRules11 = ref(1)

    let isTpyeUrl =  ref("")
    let isExUrl  =  ref("")
    let isText  =  ref("")

    let SubjectGroup =  ref("")
    let SubjectGroupList = ref([])

    onMounted(()=>{

        SubjectGroupList.value = JSON.parse(sessionStorage.getItem('SubjectGroupList'))
        getListData()
        getStudentscopy({studentType: 2, state: 1,  realname: '',}).then((res) => {  getStudentsArrs.value = res.data })
        getStudentscopy({studentType: 1, state: 1,  realname: '',}).then((res) => {  getStudentsArr_ss.value = res.data })
        //  dataList.value = [{ ownerDate: '2024-11-31', teacherName:'岁岁平岁岁安·岁岁平安', classNum:'123' }]
        handleGetTeacher()
        getStudentscopy({studentType: 2, state: 1,  realname: '',}).then((res) => {  getStudentsArr.value = res.data })
        getStudentscopy({studentType: 1, state: 1,  realname: '',}).then((res) => {  getStudentsArr_s.value = res.data })
        getcategoryList().then((res) => {  categoryList.value = res.data })
        getOptionsList()

    })



    const studentChange222 = (e) => {
      if(e){
      }else{
        getStudentscopy({studentType: 2, state: 1,  realname: '',}).then((res) => {  getStudentsArr.value = res.data })
      }
    }

    const handleInput222 = (e) => {
      getStudentscopy({studentType: 2, state: 1,  realname: e,}).then((res) => {  getStudentsArr.value = res.data })
    }


    const studentChange22 = (e) => {
      if(e){
      }else{
        getStudentscopy({studentType: 2, state: 1,  realname: '',}).then((res) => {  getStudentsArr_s.value = res.data })
      }
    }

    const handleInput22 = (e) => {
      getStudentscopy({studentType: 2, state: 1,  realname: e,}).then((res) => {  getStudentsArr_s.value = res.data })
    }






    const studentChange = (e) => {
      if(e){
      }else{
        getStudentscopy({studentType: 2, state: 1,  realname: '',}).then((res) => {  getStudentsArrs.value = res.data })
      }
    }

    const studentChange1 = (e) => {
       if(e){
      }else{
        getStudentscopy({studentType: 1, state: 1,  realname: '',}).then((res) => {  getStudentsArr_ss.value = res.data })
      }
    }

    const handleInput = (e) => {
      getStudentscopy({studentType: 2, state: 1,  realname: e,}).then((res) => {  getStudentsArrs.value = res.data })
    }

    const handleInput1 = (e) => {
      getStudentscopy({studentType: 1, state: 1,  realname: e,}).then((res) => {  getStudentsArr_ss.value = res.data })
    }


    onUpdated(() => {
        nextTick(() => {
            handleInit()

            let cellDom = document.querySelectorAll('.cell')

            for (let element of cellDom) {
                // if(element.innerHTML === '实际课消次数'){
                //     element.style.color = 'rgb(245, 140, 75)'
                // }
                // if(element.innerHTML === '实际课消金额'){
                //     element.style.color = 'rgb(209, 198, 51)'
                // }
                // if(element.innerHTML === '未课消次数'){
                //     element.style.color = 'rgb(150, 233, 149)'
                // }
                // if(element.innerHTML === '未课消金额'){
                //     element.style.color = 'rgb(194, 245, 75)'
                // }
                // if(element.innerHTML === '预课消总次数'){
                //     element.style.color = 'rgb(93, 235, 158)'
                // }
                // if(element.innerHTML === '预课消总金额'){
                //     element.style.color = 'rgb(227, 154, 89)'
                // }

            }

        })
    })

    const getOptionsList = () => {
      axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
        optionsListt.value = res.data.data
        console.log("%c Line:760 🥓 optionsListt.value", "color:#7f2b82", optionsListt.value);
      })
    }

    const getOptions = () => {
        return request({
            url: '/api/manager/courseSalesStatistics/getOptions',
            method: 'get'
        })
    }

    const getTableData = () => {
        getTableDataList().then(res => {
            if (res.code === 200) {
                tableData.value = res.data
            }
        })
    }

    const formatDate = (date) =>{
        return date.toISOString().split('T')[0];
    }

    const handleInit = () =>{
        const today = new Date()
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 2)
        const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1)


        let firstDayOfMonthNew = formatDate(firstDayOfMonth)
        let lastDayOfMonthNew = formatDate(lastDayOfMonth)

      setTimeout(()=>{
          // dateTimeList.value[0] = firstDayOfMonthNew
          // dateTimeList.value[1] = lastDayOfMonthNew
          // dateTimeList_s.value[0] = firstDayOfMonthNew
          // dateTimeList_s.value[1] = lastDayOfMonthNew
      },1000)
    }

    const handleClick = (tab, event) =>{

          console.log(tab, event);

          channelType.value = ''
          courseCategoryIds.value = ''

          if(tab.index === 3 || tab.index === '3'){
            clearBtns1()
            getStudentscopy({studentType: 2, state: 1,  realname: '',}).then((res) => {  getStudentsArr.value = res.data })
            getStudentscopy({studentType: 1, state: 1,  realname: '',}).then((res) => {  getStudentsArr_s.value = res.data })
            getListData1()
          }

          if(tab.index === 4 || tab.index === '4'){
            isTpyeUrl.value = '/classSales/querySaleClassSales'
            isExUrl.value = '/classSales/excelSaleClassSales'
            isText.value = '销售统计'
            getListData11()
          }

          if(tab.index === 5 || tab.index === '5'){
            isTpyeUrl.value = '/classSales/queryDiagnoseClassSales'
            isExUrl.value = '/classSales/excelDiagnoseClassSales'
            isText.value = '诊断师统计'
            getListData11()
          }


          if(tab.index === 6 || tab.index === '6'){
            isTpyeUrl.value = '/classSales/queryProjectClassSales'
            isExUrl.value = '/classSales/excelProjectClassSales'
            isText.value = '规划师统计'
            getListData11()
          }


          if(tab.index === 7 || tab.index === '7'){
            isTpyeUrl.value = '/classSales/querySubjectClassSales'
            isExUrl.value = '/classSales/excelProjectClassSales11'
            isText.value = '学科组统计'
            getListData111()
          }


          if(tab.paneName === 'first'){
            requestType.value = ''
            sortingRuless.value = 1
            handleTpyeCler(tab.paneName)
          }

          if(tab.paneName === 'second'){
            getStudentscopy({studentType: 2, state: 1,  realname: '',}).then((res) => {  getStudentsArrs.value = res.data })
            getStudentscopy({studentType: 1, state: 1,  realname: '',}).then((res) => {  getStudentsArr_ss.value = res.data })
            requestType.value = 'requestType'
            sortingRules.value = 1
            handleTpyeCler(tab.paneName)
          }

          if(tab.paneName === 'actualCourseConsumptionStatistics'){
            axios.get(`${apiBaseUrl}/reality_classSales/findCollect`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {

                if(response.data.code == 200){
                  const data = response.data
                  TotalAmountOfCourseCancellations.value = data.data.courseStayMoney
                  TotalCourseHoursToBeCancelled.value = data.data.courseStayHour
                  TodaysTotalAmountOfNewlyAddedClassExpenses.value = data.data.todayClassSalesMoney
                  TodaysNewlyAddedClassHours.value = data.data.todayClassSalesHour
                }else{
                  TotalAmountOfCourseCancellations.value = 0
                  TotalCourseHoursToBeCancelled.value = 0
                  TodaysTotalAmountOfNewlyAddedClassExpenses.value = 0
                  TodaysNewlyAddedClassHours.value = 0
                }

            }).catch(error => {
                handleMessage(error, 'error')
            })
            handleInitList(tab.paneName)
          }

    }


    const handleInitList = (value) =>{
      getListDataalCourseConsumptionStatistics()
    }


    const handleTpyeCler = (bomb) =>{
        dateTimeList.value[0] = firstDay
        dateTimeList.value[1] = currentDay
        dateTimeList_s.value[0] = firstDay
        dateTimeList_s.value[1] = currentDay

        if(bomb === 'first'){
            clearBtns()
        }else{
            handleCler()
        }
    }

    const handleCler = () =>{
      cancellationsNumber_s.value = ""
      cancellationsMoney_s.value = ""
      // dateTimeList_s.value = []
      student_s.value = ""
      student.value = ""
      newClassType.value = ""

      let str = []
      if(student.value){
        str.push(student.value)
        if(student_s.value){
          str.push(student_s.value)
        }
      }else{
        if(student_s.value){
          str.push(student_s.value)
        }
      }

      if(dateTimeList_s.value && dateTimeList_s.value.length > 0){
        let data = {
            pageNo: 1,
            pageSize:  10,
            studentList: str.length > 0 ? str : null,
            startTime: dateTimeList_s.value[0],
            endTime: dateTimeList_s.value[1],
            salesNum: cancellationsNumber_s.value,
            salesMoney: cancellationsMoney_s.value,
            sortingRules: sortingRuless.value,
            classType: newClassType.value ? newClassType.value : '',
        }

        getListData(data)
      }else{
        let data = {
              pageNo:  1,
              pageSize:  10,
              studentList:  str.length > 0 ? str : null,
              startTime: firstDay,
              endTime: currentDay,
              salesNum: cancellationsNumber_s.value,
              salesMoney: cancellationsMoney_s.value,
              classType: newClassType.value ? newClassType.value : '',
            }
          getListData(data)
      }

    }

    let handleClerss111 = () =>{
        channelType.value = ""
        SubjectGroup.value = ""
        cancellationsNumber.value = ""
        cancellationsMoney.value = ""
        newClassType.value = ""
        regionName.value = ""
        courseCategoryIds.value = ""
        dateTimeList.value = [firstDay, currentDay]
        getListData111()
    }


    const handleClerss = () =>{
      cancellationsNumber_s.value = ""
      cancellationsMoney_s.value = ""
      SubjectGroup.value = ""
      // dateTimeList_s.value = []
      student_s.value = ""
      student.value = ""
      newClassType.value = ""

      let str = []
      if(student.value){
        str.push(student.value)
        if(student_s.value){
          str.push(student_s.value)
        }
      }else{
        if(student_s.value){
          str.push(student_s.value)
        }
      }

      if(dateTimeList_s.value && dateTimeList_s.value.length > 0){
        let data = {
            pageNo: 1,
            pageSize:  10,
            studentList: str.length > 0 ? str : null,
            startTime: dateTimeList_s.value[0],
            endTime: dateTimeList_s.value[1],
            salesNum: cancellationsNumber_s.value,
            salesMoney: cancellationsMoney_s.value,
            sortingRules: sortingRuless.value,
            classType: newClassType.value ? newClassType.value : '',
        }

        getListData(data)
      }else{
        let data = {
              pageNo:  1,
              pageSize:  10,
              studentList:  str.length > 0 ? str : null,
              startTime: firstDay,
              endTime: currentDay,
              salesNum: cancellationsNumber_s.value,
              salesMoney: cancellationsMoney_s.value,
              classType: newClassType.value ? newClassType.value : '',
            }
          getListData(data)
      }

    }

    

    let exportBtns = () =>{

      if(requestType.value === 'requestType'){
          let str = []
          if(student.value){
            str.push(student.value)
            if(student_s.value){
              str.push(student_s.value)
            }
          }else{
            if(student_s.value){
                str.push(student_s.value)
            }
          }
          let data = {
              studentList: str.length > 0 ? str : null,
              startTime: dateTimeList_s.value[0],
              endTime: dateTimeList_s.value[1],
              salesNum: cancellationsNumber_s.value,
              salesMoney: cancellationsMoney_s.value,

              sortingRules: sortingRules.value,
              pageNo: 1,
              pageSize: 10000,
              teacherId: teacherName.value,
              regionName:regionName.value || localStorage.getItem('cityTepy'),
              classType: newClassType.value ? newClassType.value : '',


              categoryId: courseCategoryIds.value ? courseCategoryIds.value : '',
          }
          axios.post(`${apiBaseUrl}/classSales/excelStuClassSales`, data, { responseType: "blob",
          headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
            if(response.status == 200){

              const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
              const downloadLink = document.createElement("a");
              downloadLink.href = URL.createObjectURL(blob);
              downloadLink.download = "课消统计(学生统计).xlsx";
              downloadLink.click();

              handleMessage('导出成功', 'success')
            }else{
              handleMessage('导出失败', 'error')
            }
          })
      }else{
        let data = {
          teacherId: teacherName.value,
          // courseStartTime: dateTimeList.value[0],
          // courseEndTime: dateTimeList.value[1],
          startTime: dateTimeList.value[0],
          endTime: dateTimeList.value[1],
          salesNum: cancellationsNumber.value,
          salesMoney: cancellationsMoney.value,


          sortingRules: sortingRules.value,
          pageNo: 1,
          pageSize: 10000,
          teacherId: teacherName.value,
          regionName:regionName.value || localStorage.getItem('cityTepy'),

          categoryId: courseCategoryIds.value ? courseCategoryIds.value : ''

        }
        axios.post(`${apiBaseUrl}/classSales/excelClassSales`, data, { responseType: "blob",
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')

        } }).then(response => {
          if(response.status == 200){

            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = "课消统计(老师统计).xlsx";
            downloadLink.click();

            handleMessage('导出成功', 'success')
          }else{
            handleMessage('导出失败', 'error')
          }
        })
      }


    }

    let exportBtnss = () =>{
      axios.get(`${apiBaseUrl}/classSales/createClassSales`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(response => {
          if(response.data.code == 200){
            let data = {
              pageNo: requestParameters.pageNum ? requestParameters.pageNum : 1,
              pageSize: requestParameters.pageSize,
            }

            handleMessage('操作成功', 'success')

            setTimeout(()=>{
              getListData(data)
            },1000)

          }else{
            handleMessage('操作失败', 'error')
          }
      })
    }

    let exportBtnss11 = () =>{
      axios.get(`${apiBaseUrl}/classSales/excelSaleClassSales`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(response => {
          if(response.data.code == 200){
            let data = {
              pageNo: requestParameters.pageNum ? requestParameters.pageNum : 1,
              pageSize: requestParameters.pageSize,
            }

            handleMessage('操作成功', 'success')

            setTimeout(()=>{
              getListData11(data)
            },1000)

          }else{
            handleMessage('操作失败', 'error')
          }
      })
    }

    let exportBtns11 = () =>{
      let data = {
          teacherId: teacherName.value,
          // courseStartTime: dateTimeList.value[0],
          // courseEndTime: dateTimeList.value[1],
          startTime: dateTimeList.value[0],
          endTime: dateTimeList.value[1],
          salesNum: cancellationsNumber.value,
          salesMoney: cancellationsMoney.value,


          sortingRules: sortingRules.value,
          pageNo: 1,
          pageSize: 10000,
          teacherId: teacherName.value,
          regionName:regionName.value || localStorage.getItem('cityTepy'),
        }

        let url = isExUrl.value

        axios.post(`${apiBaseUrl}${url}`, data, { responseType: "blob",
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')

        } }).then(response => {
          if(response.status == 200){

            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download =  isText.value + ".xlsx";
            downloadLink.click();

            handleMessage('导出成功', 'success')
          }else{
            handleMessage('导出失败', 'error')
          }
        })
    }

    let clearBtns11 = () =>{
      channelType.value = ""
      requestParameters11.pageNum = 1
      requestParameters11.pageSize = 10
      teacherName11.value = ""
      cancellationsNumber11.value = ""
      cancellationsMoney11.value = ""
      regionName11.value = ""
      newClassType11.value = ""
      dateTimeList11.value = [firstDay, currentDay]
      getListData11()
    }

    let clearBtns = () =>{
      channelType.value = ""
      if(requestType.value !== 'requestType'){
          // dateTimeList.value = []
          teacherName.value = ""
          cancellationsNumber.value = ""
          cancellationsMoney.value = ""
          regionName.value = ""
          newClassType.value = ""

        if(dateTimeList.value && dateTimeList.value.length > 0){
          let data = {
            pageNo: 1,
            pageSize: 10,
            teacherId: teacherName.value,
            // courseStartTime: dateTimeList.value[0],
            // courseEndTime: dateTimeList.value[1],
            startTime: dateTimeList.value[0],
            endTime: dateTimeList.value[1],
            salesNum: cancellationsNumber.value,
            salesMoney: cancellationsMoney.value,
            sortingRules: sortingRules.value,
            classType: newClassType.value ? newClassType.value : '',
          }

          getListData(data)
        }else{
            let data = {
              pageNo:  1,
              pageSize: 10,
              teacherId: teacherName.value,
              startTime: firstDay,
              endTime: currentDay,
              salesNum: cancellationsNumber.value,
              salesMoney: cancellationsMoney.value,
              sortingRules: sortingRules.value,
              classType: newClassType.value ? newClassType.value : '',
            }
            getListData(data)
        }
      }else{
        handleCler()
      }
    }


    const handleQueryType = (destroyer) =>{
      if(destroyer === 'bomm'){

          // dateTimeList.value = []
          teacherName.value = ""
          cancellationsNumber.value = ""
          cancellationsMoney.value = ""

          let data = {
            pageNo: requestParameters.pageNum ? requestParameters.pageNum : 1,
            pageSize: requestParameters.pageSize ? requestParameters.pageSize : 10,
            teacherId: teacherName.value,
            startTime: dateTimeList.value[0],
            endTime: dateTimeList.value[1],
            salesNum: cancellationsNumber.value,
            salesMoney: cancellationsMoney.value,
            sortingRules: sortingRuless.value,
          }

          getListData(data)
      }
      if(destroyer === 'blast'){
          cancellationsNumber_s.value = ""
          cancellationsMoney_s.value = ""
          // dateTimeList_s.value = []
          student_s.value = ""
          student.value = ""


          let str = []
          if(student.value){
            str.push(student.value)
            if(student_s.value){
              str.push(student_s.value)
            }
          }else{
            if(student_s.value){
                str.push(student_s.value)
            }
          }

          let data = {
            pageNo: requestParameters_s.pageNum ? requestParameters_s.pageNum : 1,
            pageSize: requestParameters_s.pageSize ? requestParameters_s.pageSize : 10,
            studentList:  str.length > 0 ? str : null,
            startTime: dateTimeList_s.value[0],
            endTime: dateTimeList_s.value[1],
            salesNum: cancellationsNumber_s.value,
            salesMoney: cancellationsMoney_s.value,
            sortingRules: sortingRuless.value,
          }

          getListData(data)
      }
    }

    const store = useStore()


    // 老师统计详情
    let details = (row) =>{
        row.courseCategoryIds = courseCategoryIds.value 
        row.channelType = channelType.value 
        store.row = row
        DetailsRow = row
        
        ShowCourseSalesStatisticsDetails.value = true
    }

    // 销售统计详情
     let detailss11 = (row) =>{
        row.courseCategoryIds = courseCategoryIds.value 
        row.channelType = channelType.value 
        store.row = row

        TimeList.value[0] = dateTimeList11.value[0]
        TimeList.value[1]  = dateTimeList11.value[1]
        row.isType = isText.value 
        DetailsRow = row
        ShowCourseSalesStatisticsDetails.value = true
    }

    // 赠送统计详情
    let details1 = (row) =>{
        row.channelType = channelType.value 
        row.courseCategoryIds = courseCategoryIds.value 
        store.row = row
        TimeList.value[0] = dateTimeList1.value[0]
        TimeList.value[1]  = dateTimeList1.value[1]
        row.courseCategoryIds = courseCategoryIds.value 
        DetailsRow = row
        ShowCourseSalesStatisticsDetails_s.value = true
    }

    // 学生统计详情
    let details_s = (row) =>{
        row.channelType = channelType.value 
        row.courseCategoryIds = courseCategoryIds.value 
        store.row = row
        DetailsRow = row
        row.courseCategoryIds = courseCategoryIds.value 
        ShowCourseSalesStatisticsDetails_s.value = true
        
    }

    let searchBtns11 = () =>{
      getListData11()
    }

    let searchBtns = ()  =>{


      if(requestType.value  != 'requestType'){
        if(dateTimeList.value && dateTimeList.value.length > 0){
          let data = {
            pageNo:  1,
            pageSize: requestParameters.pageSize,
            teacherId: teacherName.value,
            // courseStartTime: dateTimeList.value[0],
            // courseEndTime: dateTimeList.value[1],
            startTime: dateTimeList.value ? dateTimeList.value[0] : '',
            endTime: dateTimeList.value ? dateTimeList.value[1] : '',
            salesNum: cancellationsNumber.value,
            salesMoney: cancellationsMoney.value,
            sortingRules: sortingRules.value,
            regionName:regionName.value || localStorage.getItem('cityTepy'),
            classType: newClassType.value ? newClassType.value : '',
          }
          getListData(data)
        }else{
          let data = {
            pageNo:  1,
            pageSize: requestParameters.pageSize,
            teacherId: teacherName.value,
            startTime: firstDay,
            endTime: currentDay,
            salesNum: cancellationsNumber.value,
            salesMoney: cancellationsMoney.value,
            sortingRules: sortingRules.value,
            regionName:regionName.value  || localStorage.getItem('cityTepy'),
            classType: newClassType.value ? newClassType.value : '',
          }
          getListData(data)
        }
      }else{
          let str = []
          if(student.value){
            str.push(student.value)
            if(student_s.value){
              str.push(student_s.value)
            }
          }else{
            if(student_s.value){
                str.push(student_s.value)
            }
          }

          if(dateTimeList_s.value && dateTimeList_s.value.length > 0){
            let data = {
              pageNo: 1,
              pageSize: requestParameters_s.pageSize ? requestParameters_s.pageSize : 10,
              studentList:  str.length > 0 ? str : null,
              startTime: dateTimeList_s.value[0] ? dateTimeList_s.value[0] : '',
              endTime: dateTimeList_s.value[1] ? dateTimeList_s.value[1] : '',
              salesNum: cancellationsNumber_s.value,
              salesMoney: cancellationsMoney_s.value,
              sortingRules: sortingRuless.value,
              regionName:regionName.value || localStorage.getItem('cityTepy'),
              classType: newClassType.value ? newClassType.value : '',
            }
            getListData(data)
          }else{
            let data = {
              pageNo: 1,
              pageSize: requestParameters_s.pageSize ? requestParameters_s.pageSize : 10,
              studentList:  str.length > 0 ? str : null,
              startTime: firstDay,
              endTime: currentDay,
              salesNum: cancellationsNumber_s.value,
              salesMoney: cancellationsMoney_s.value,
              sortingRules: sortingRuless.value,
              regionName:regionName.value || localStorage.getItem('cityTepy'),
              classType: newClassType.value ? newClassType.value : '',
            }
            getListData(data)
          }
      }


    }


    const handleOnekeyCourseConsumption = () =>{

      requestParametersalCourseConsumptionStatistics.pageNum = 1
      requestParametersalCourseConsumptionStatistics.pageSize = 10



      const loadingObj =  Loading.service({ lock: true,  text: '课消中请稍等...',  spinner: 'el-icon-loading',  background: 'rgba(0, 0, 0, 0.6)'  })

      if(typeCourseConsumptionStatistics.value === 1){
        axios.get(`${apiBaseUrl}/reality_classSales/calculateMoney`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
            if(response.data.code == 200){
              handleMessage(response.data.message, 'success')
              loadingObj.close()
              getListDataalCourseConsumptionStatistics()
            }else{
              loadingObj.close()
              handleMessage(response.data.message, 'error')
            }
        }).catch(error => {
            handleMessage(error, 'error')
            loadingObj.close()
        })
      }

      if(typeCourseConsumptionStatistics.value === 2){
        axios.get(`${apiBaseUrl}/reality_classSales/calculateHour`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
            if(response.data.code == 200){
              handleMessage(response.data.message, 'success')
              loadingObj.close()
              getListDataalCourseConsumptionStatistics()
            }else{
              loadingObj.close()
              handleMessage(response.data.message, 'error')
            }
        }).catch(error => {
            handleMessage(error, 'error')
            loadingObj.close()
        })
      }


      axios.get(`${apiBaseUrl}/reality_classSales/findCollect`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {

      if(response.data.code == 200){
          const data = response.data
          TotalAmountOfCourseCancellations.value = data.data.courseStayMoney
          TotalCourseHoursToBeCancelled.value = data.data.courseStayHour
          TodaysTotalAmountOfNewlyAddedClassExpenses.value = data.data.todayClassSalesMoney
          TodaysNewlyAddedClassHours.value = data.data.todayClassSalesHour
      }else{
          TotalAmountOfCourseCancellations.value = 0
          TotalCourseHoursToBeCancelled.value = 0
          TodaysTotalAmountOfNewlyAddedClassExpenses.value = 0
          TodaysNewlyAddedClassHours.value = 0
      }

      }).catch(error => {
          handleMessage(error, 'error')
      })

    }

    let getListDataalCourseConsumptionStatistics = (data = {
      pageSize: requestParametersalCourseConsumptionStatistics.pageSize ? requestParametersalCourseConsumptionStatistics.pageSize : 10,
      pageNum: requestParametersalCourseConsumptionStatistics.pageNum ? requestParametersalCourseConsumptionStatistics.pageNum : 1,
    }) =>{
      const URL = `/reality_classSales/${typeCourseConsumptionStatistics.value === 1 ? 'findCourseMoneyPage' : 'findCourseHourPage'}`
      axios.post(`${apiBaseUrl}${URL}`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(response => {
        let data = response.data
        if (data.code == 200) {
              handleMessage('查询成功', 'success')
              if( data.data.records && data.data.records.length > 0 ){
                  requestParametersalCourseConsumptionStatistics.total = data.data.total
                  requestParametersalCourseConsumptionStatistics.pageNum = data.data.current
                  requestParametersalCourseConsumptionStatistics.pageSize = data.data.size
                  dataListactualCourseConsumptionStatistics.value = data.data.records
              }else{
                  requestParametersalCourseConsumptionStatistics.total = 0
                  requestParametersalCourseConsumptionStatistics.pageNum = 1
                  requestParametersalCourseConsumptionStatistics.pageSize = 10
                  dataListactualCourseConsumptionStatistics.value = []
              }
          }else{
            handleMessage('查询失败', 'error')
        }
        })
        .catch(error => {
          handleMessage(error, 'error')
        });
    }

    let getListData111 = (data = {
          pageSize: requestParameters11.pageSize ? requestParameters11.pageSize : 10,
          pageNo: requestParameters11.pageNum ? requestParameters11.pageNum : 1,
          teacherId: teacherName11.value,
          // courseStartTime: dateTimeList11.value[0],
          // courseEndTime: dateTimeList11.value[1],
          startTime: dateTimeList.value[0],
          endTime: dateTimeList.value[1],
          salesNum: cancellationsNumber.value,
          salesMoney: cancellationsMoney.value,
          sortingRules: sortingRules11.value,
          regionName: regionName.value || localStorage.getItem('cityTepy'),
          classType: newClassType.value ? newClassType.value : '',
          categoryId: courseCategoryIds.value ? courseCategoryIds.value : '',
          // categoryIds: courseCategoryIds.value ? courseCategoryIds.value : '',
          subjectGroupId: SubjectGroup.value ? SubjectGroup.value : '',
          channelType: channelType.value,
      }) =>{

      let url = isTpyeUrl.value
      axios.post(`${apiBaseUrl}${url}`, data,{  headers:{ 'authorization': sessionStorage.getItem('tokenInfo')   } }).then(response => {
        let list = response.data
        if (list.code == 200) {
              requestParameters11.total = list.data.allTotal
              requestParameters11.pageNum = list.data.pageIndex
              dataTop11.actualNumCount = list.data.actualNumCount ? list.data.actualNumCount : 0
              dataTop11.actualMoneyCount = list.data.actualMoneyCount ? list.data.actualMoneyCount : 0
              dataTop11.notNumCount = list.data.notNumCount ? list.data.notNumCount : 0
              dataTop11.notMoneyCount = list.data.notMoneyCount ? list.data.notMoneyCount : 0
              dataTop11.estimateNumCount = list.data.estimateNumCount ? list.data.estimateNumCount : 0
              dataTop11.estimateMoneyCount = list.data.estimateMoneyCount ? list.data.estimateMoneyCount : 0
              requestParameters.pageNum = list.data.pageIndex
              requestParameters.total = list.data.allTotal
              dataList1111.value = list.data.classSales
          }else{ 
            handleMessage('查询失败', 'error')
            requestParameters11.total = 0
            requestParameters11.pageNum = 1
            requestParameters11.pageSize = 10
            dataList1111.value = []
            requestParameters.pageNum = 1
            requestParameters.total = 0
            dataTop11.actualNumCount = 0
            dataTop11.actualMoneyCount = 0
            dataTop11.notNumCount = 0
            dataTop11.notMoneyCount = 0
            dataTop11.estimateNumCount = 0
            dataTop11.estimateMoneyCount = 0
        }
        })
        .catch(error => {
          console.error(error)
        });   
      
    }

    let getListData11 = (data = {
        pageSize: requestParameters11.pageSize ? requestParameters11.pageSize : 10,
        pageNo: requestParameters11.pageNum ? requestParameters11.pageNum : 1,
        teacherId: teacherName11.value,
        // courseStartTime: dateTimeList11.value[0],
        // courseEndTime: dateTimeList11.value[1],
        startTime: dateTimeList11.value[0],
        endTime: dateTimeList11.value[1],
        salesNum: cancellationsNumber11.value,
        salesMoney: cancellationsMoney11.value,
        sortingRules: sortingRules11.value,
        regionName: regionName11.value || localStorage.getItem('cityTepy'),
        classType: newClassType11.value ? newClassType11.value : '',
        categoryId: courseCategoryIds.value ? courseCategoryIds.value : '',
    }) => {
      data.channelType = channelType.value

      let url = isTpyeUrl.value
      axios.post(`${apiBaseUrl}${url}`, data,{  headers:{ 'authorization': sessionStorage.getItem('tokenInfo')   } }).then(response => {
        let list = response.data
        if (list.code == 200) {
              requestParameters11.total = list.data.allTotal
              requestParameters11.pageNum = list.data.pageIndex
              dataTop11.actualNumCount = list.data.actualNumCount ? list.data.actualNumCount : 0
              dataTop11.actualMoneyCount = list.data.actualMoneyCount ? list.data.actualMoneyCount : 0
              dataTop11.notNumCount = list.data.notNumCount ? list.data.notNumCount : 0
              dataTop11.notMoneyCount = list.data.notMoneyCount ? list.data.notMoneyCount : 0
              dataTop11.estimateNumCount = list.data.estimateNumCount ? list.data.estimateNumCount : 0
              dataTop11.estimateMoneyCount = list.data.estimateMoneyCount ? list.data.estimateMoneyCount : 0
              dataList11.value = list.data.classSales
          }else{
            handleMessage('查询失败', 'error')
            requestParameters11.total = 0
            requestParameters11.pageNum = 1
            requestParameters11.pageSize = 10
            dataList11.value = []
            dataTop11.actualNumCount = 0
            dataTop11.actualMoneyCount = 0
            dataTop11.notNumCount = 0
            dataTop11.notMoneyCount = 0
            dataTop11.estimateNumCount = 0
            dataTop11.estimateMoneyCount = 0
        }
        })
        .catch(error => {
          console.error(error)
        });   
    }


    let getListData = (data = {
        pageSize: requestParameters.pageSize, pageNo: requestParameters.pageNum,
        teacherId: teacherName.value,
        // courseStartTime: dateTimeList.value[0],
        // courseEndTime: dateTimeList.value[1],
        startTime: dateTimeList.value[0],
        endTime: dateTimeList.value[1],
        salesNum: cancellationsNumber.value,
        salesMoney: cancellationsMoney.value,
        sortingRules: requestType.value  === 'requestType' ? sortingRuless.value : sortingRules.value,
        regionName: regionName.value || localStorage.getItem('cityTepy'),
        classType: newClassType.value ? newClassType.value : '',
        categoryId: courseCategoryIds.value ? courseCategoryIds.value : ''
    }) => {
      data.categoryId = courseCategoryIds.value ? courseCategoryIds.value : ''
      data.channelType = channelType.value
      let URL = ''
      if(requestType.value  === 'requestType'){
            TimeList.value = dateTimeList_s.value
            URL = '/classSales/queryStuClassSales'
      }else{
            TimeList.value = dateTimeList.value
            URL = '/classSales/queryClassSales'
      }

      axios.post(`${apiBaseUrl}${URL}`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(response => {

        let list = response.data
        if (list.code == 200) {
              if(requestType.value  === 'requestType'){
                  requestParameters_s.total = list.data.allTotal
                  requestParameters_s.pageNum = list.data.pageIndex
                  dataTop_s.actualNumCount = list.data.actualNumCount ? list.data.actualNumCount : 0
                  dataTop_s.actualMoneyCount = list.data.actualMoneyCount ? list.data.actualMoneyCount : 0
                  dataTop_s.notNumCount = list.data.notNumCount ? list.data.notNumCount : 0
                  dataTop_s.notMoneyCount = list.data.notMoneyCount ? list.data.notMoneyCount : 0
                  dataTop_s.estimateNumCount = list.data.estimateNumCount ? list.data.estimateNumCount : 0
                  dataTop_s.estimateMoneyCount = list.data.estimateMoneyCount ? list.data.estimateMoneyCount : 0
                  dataList_s.value = list.data.classSales
              }else{
                  requestParameters.total = list.data.allTotal
                  requestParameters.pageNum = list.data.pageIndex
                  dataTop.actualNumCount = list.data.actualNumCount ? list.data.actualNumCount : 0
                  dataTop.actualMoneyCount = list.data.actualMoneyCount ? list.data.actualMoneyCount : 0
                  dataTop.notNumCount = list.data.notNumCount ? list.data.notNumCount : 0
                  dataTop.notMoneyCount = list.data.notMoneyCount ? list.data.notMoneyCount : 0
                  dataTop.estimateNumCount = list.data.estimateNumCount ? list.data.estimateNumCount : 0
                  dataTop.estimateMoneyCount = list.data.estimateMoneyCount ? list.data.estimateMoneyCount : 0
                  dataList.value = list.data.classSales
              }
          }else{
            handleMessage('查询失败', 'error')
        }
        })
        .catch(error => {
          console.error(error)
        });
    }

    let handleMessage = (message , type)=>{
      $Vue.$message({ message, type, duration: 500 })

    }


    let handleGetTeacher = () =>{
      getTeachers_s().then((res) => {
        teacherArr.value = res.data
      })

      teacherArrs.value = JSON.parse(sessionStorage.getItem('customersaleObj'))

      getTeachers_sss().then((res) => {
        teacherArrss.value = res.data
      })

      getTeachers_ssss().then((res) => {
        teacherArrsss.value = res.data
      })
    }


    let handleCurrentChange = (current) =>{
        requestParameters.pageNum = current
        getListData()
    }

     let handleCurrentChangesss = (current) =>{
        requestParameters.pageNum = current
        getListData111()
    }

     let handleCurrentChange1 = (current) =>{
        requestParameters1.pageNum = current
        getListData1()
     }

    let handleCurrentChange11 = (current) =>{
        requestParameters11.pageNum = current
        getListData11()
     }

    let handleCurrentChangealCourseConsumptionStatistics = (current) =>{
        requestParametersalCourseConsumptionStatistics.pageNum = current
        getListDataalCourseConsumptionStatistics()
    }

    let handleSizeChangealCourseConsumptionStatistics = (current) =>{
        requestParametersalCourseConsumptionStatistics.pageNum = current
        getListDataalCourseConsumptionStatistics()
    }


    let handleSizeChange = (Size) =>{
        requestParameters.pageSize = Size
        getListData()
    }

    let handleSizeChangessss = (Size) =>{
        requestParameters.pageSize = Size
        getListData111()
    }

    let handleSizeChange1 = (Size) =>{
        requestParameters1.pageSize = Size
        getListData1()
    }
     let handleSizeChange11 = (Size) =>{
        requestParameters11.pageSize = Size
        getListData11()
    }



    let getListData1 = ()=>{

      let str = []
      if(student1.value){
        str.push(student1.value)
        if(student_s1.value){
          str.push(student_s1.value)
        }
      }else{
        if(student_s1.value){
            str.push(student_s.value)
        }
      }
      
      let data = {
         pageNo: requestParameters1.pageNum,
         pageSize:  requestParameters1.pageSize,
         startTime: dateTimeList1.value.length > 0 ? dateTimeList1.value[0] : null,
         endTime: dateTimeList1.value.length > 1 ? dateTimeList1.value[1] : null,
         studentList: str.length > 0 ? str.join(",") : null,
         regionName: regionName1.value || localStorage.getItem('cityTepy'),
         salesNum: cancellationsNumber1.value,
        //  salesMoney: cancellationsMoney1.value,
        //  sortingRules: sortingRules1.value,
         classType: newClassType1.value ? newClassType1.value : '',
         categoryId: courseCategoryIds.value ? courseCategoryIds.value : '',
         channelType: channelType.value,
       }
       axios.post(`${apiBaseUrl}/classSales/queryStuGiveSales`, data,{  headers:{  'authorization': sessionStorage.getItem('tokenInfo') }  }).then(response => {
         let res = response.data
         console.log("%c Line: 1 🥓 response", "color:#7f2b82", res);
         if(res.code === 200){
           dataList1.value = res.data.classSales
           requestParameters1.total = res.data.allTotal
           actualNumCountAll.value = res.data.actualNumCount
         }else{
           dataList1.value = []
           requestParameters1.pageNum = 1
           requestParameters1.pageSize = 10
           requestParameters1.total = 0
           actualNumCountAll.value = 0
         }
       }).catch(error => {
         console.error("Error:", error);
         dataList1.value = []
         requestParameters1.pageNum = 1
         requestParameters1.pageSize = 10
         requestParameters1.total = 0
          actualNumCountAll.value = 0
         handleMessage(error, 'error')
       })
    }

    let handleCurrentChange_s = (current) =>{
        requestParameters_s.pageNum = current
        let str = []
          if(student.value){
            str.push(student.value)
            if(student_s.value){
              str.push(student_s.value)
            }
          }else{
            if(student_s.value){
                str.push(student_s.value)
            }
          }
        let data = {
              pageNo: requestParameters_s.pageNum ? requestParameters_s.pageNum : 1,
              pageSize: requestParameters_s.pageSize ? requestParameters_s.pageSize : 10,
              studentList:  str.length > 0 ? str : null,
              startTime: dateTimeList_s.value[0] ? dateTimeList_s.value[0] : '',
              endTime: dateTimeList_s.value[1] ? dateTimeList_s.value[1] : '',
              salesNum: cancellationsNumber_s.value,
              salesMoney: cancellationsMoney_s.value,
              sortingRules: sortingRules.value,
              regionName:regionName.value  || localStorage.getItem('cityTepy'),
              classType: newClassType.value ? newClassType.value : '',

            }
            getListData(data)
    }

    let handleSizeChange_s = (Size) =>{
        requestParameters_s.pageSize = Size
        let str = []
          if(student.value){
            str.push(student.value)
            if(student_s.value){
              str.push(student_s.value)
            }
          }else{
            if(student_s.value){
                str.push(student_s.value)
            }
          }
        let data = {
              pageNo: requestParameters_s.pageNum ? requestParameters_s.pageNum : 1,
              pageSize: requestParameters_s.pageSize ? requestParameters_s.pageSize : 10,
              studentList:  str.length > 0 ? str : null,
              startTime: dateTimeList_s.value[0] ? dateTimeList_s.value[0] : '',
              endTime: dateTimeList_s.value[1] ? dateTimeList_s.value[1] : '',
              salesNum: cancellationsNumber_s.value,
              salesMoney: cancellationsMoney_s.value,
              sortingRules: sortingRules.value,
              regionName:regionName.value  || localStorage.getItem('cityTepy'),
              classType: newClassType.value ? newClassType.value : '',
            }
            getListData(data)
    }


    let handleEmitButs = (event, destroyer) =>{
        ShowCourseSalesStatisticsDetails.value = event
        ShowCourseSalesStatisticsDetails_s.value = event

        handleQueryType(destroyer)

        getListData1()  

    }

    let handleEmitButss = (event, destroyer) =>{
        ShowCourseSalesStatisticsDetails.value = event
        ShowCourseSalesStatisticsDetails_s.value = event
        getListData11()
    }


    let handleClickTab = (type)=>{
        if(type === 1 || type === 2){
            requestParametersalCourseConsumptionStatistics.total = 0
            requestParametersalCourseConsumptionStatistics.pageNum = 1
            requestParametersalCourseConsumptionStatistics.pageSize = 10
            dataListactualCourseConsumptionStatistics.value = []
            typeCourseConsumptionStatistics.value = type
            getListDataalCourseConsumptionStatistics()
        }
    }


    let changeSortingRules = (event) =>{
      getListData()
    }

     let changeSortingRules11 = (event) =>{
      getListData()
    }

    let changeSortingRuless = (event) =>{
      getListData()
    }

    let searchBtns1 = ()=>{
      getListData1()
    }

   let  searchBtns111= ()=>{
      getListData111()
    }

    let clearBtns1 = ()=>{
      getStudentscopy({studentType: 2, state: 1,  realname: '',}).then((res) => {  getStudentsArrs.value = res.data })
      getStudentscopy({studentType: 1, state: 1,  realname: '',}).then((res) => {  getStudentsArr_ss.value = res.data })
      getStudentscopy({studentType: 2, state: 1,  realname: '',}).then((res) => {  getStudentsArr.value = res.data })
      getStudentscopy({studentType: 1, state: 1,  realname: '',}).then((res) => {  getStudentsArr_s.value = res.data })
      channelType.value = ""
      student1.value = ""
      student_s1.value = ""
      cancellationsNumber1.value = ""
      cancellationsMoney1.value = ""
      newClassType1.value = ""
      regionName1.value = ""
      dateTimeList1.value = [firstDay, currentDay]
      requestParameters1.pageNum = 1
      requestParameters1.pageSize = 10
      getListData1()
    }

    return {
      handleClickTab,
      requestParameters,
      dateTimeList,
      teacherName,
      cancellationsNumber,
      cancellationsMoney,
      dataList,
      teacherArr,
      ShowCourseSalesStatisticsDetails,
      ShowCourseSalesStatisticsDetails_s,
      DetailsRow,
      TimeList,
      dataTop,
      activeName,
      getStudentsArr,
      getStudentsArrs,
      getStudentsArr_s,
      getStudentsArr_ss,
      student,
      student_s,
      cancellationsNumber_s,
      cancellationsMoney_s,
      dateTimeList_s,
      requestParameters_s,
      handleCurrentChange_s,
      handleSizeChange_s,
      dataTop_s,
      dataList_s,

      exportBtnss,
      exportBtns,
      searchBtns,
      clearBtns,
      getListData,
      isTpyeUrl,
      isExUrl,

      handleEmitButs,
      details,
      details_s,
      formatDate,
      handleCurrentChange,
      handleSizeChange,

      handleMessage,
      handleGetTeacher,
      handleClick,
      handleTpyeCler,
      handleInit,

      handleInitList,
      dataListactualCourseConsumptionStatistics,
      handleCurrentChangealCourseConsumptionStatistics,
      handleSizeChangealCourseConsumptionStatistics,
      requestParametersalCourseConsumptionStatistics,
      handleOnekeyCourseConsumption,
      typeCourseConsumptionStatistics,

      TotalAmountOfCourseCancellations,
      TotalCourseHoursToBeCancelled,
      TodaysTotalAmountOfNewlyAddedClassExpenses,
      TodaysNewlyAddedClassHours,

      sortingRules,
      sortingRulesArr,
      changeSortingRules,
      sortingRuless,
      changeSortingRuless,

      SubjectGroupList,

      handleCurrentChangesss,
      handleSizeChangessss,
      SubjectGroup,

      teacherArrss,
      teacherArrsss,


      optionsListt,
      regionName,

      searchBtns11,
      detailss11,


      newClassTypeList,
      newClassType,


      student1,
      student_s1,
      cancellationsNumber1,
      cancellationsMoney1,
      newClassType1,
      regionName1,
      dateTimeList1,

      dataList1,
      requestParameters1,
      actualNumCountAll,

      DealTypeListt,
      channelType,

      details1,
      handleCurrentChange1,
      handleSizeChange1,

      getListData1,  

      searchBtns111,
      searchBtns1,
      clearBtns1,


      teacherName11,
      cancellationsNumber11,
      cancellationsMoney11,
      newClassType11,
      regionName11,
      dateTimeList11,
      dataList11,
      requestParameters11,
      dataTop11,
      sortingRules11,


      changeSortingRules11,
      exportBtnss11,
      getListData11,
      exportBtns11,
      clearBtns11,

      handleCurrentChange11,
      handleSizeChange11,
      isText,

      handleClerss111,


      propsCategory,
      categoryList,
      courseCategoryIds,
      handleClerss,
      teacherArrs,
      dataList1111,
      handleEmitButss,
      studentChange,
      studentChange1,
      handleInput,
      handleInput1,


      studentChange222,
      handleInput222,
      studentChange22,
      handleInput22,

    }



  }

}


</script>

<style scoped>
.select {
  display: flex;
  flex-wrap: wrap;
}

@media screen and (max-width: 750px) {
  .sales-statistics {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.sales-statistics {
    width: 70% !important;
  }
}

.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}



.glow-effect {
  position: relative;
  overflow: hidden;
}

.glow-effect::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, #0fb2f6, #18dec5, #0fb2f6);
  background-size: 400% 400%;
  animation: glow 5s ease-in-out infinite;
  z-index: -1;
}

@keyframes glow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.clickable-text {
  color: red;
  cursor: pointer;
}






</style>



// WEBPACK FOOTER //
// src/manager/createComponents/CourseSalesStatistics.vue